import { LSEP, NBSP } from '../../../common/constants/symbols';
import AlternativeImg from './assets/alternative.png';
import BudgetImg from './assets/budget.png';
import BenefitImg from './assets/benefit.png';
import IncomeImg from './assets/income.png';
import CheckDetailsImg from './assets/check_details.png';
import { IAccordionItemProps, Image } from '@cian/ui-kit';

export const WHY_NEED_REALTOR_TITLE = `Зачем нужен риелтор при${NBSP}покупке`;
const itemStyles = { paddingLeft: '70px', marginTop: '-20px', color: 'var(--icon-primary-default)' };

export const WHY_NEED_REALTOR_FIRST_ACCORDION_COLUMNS: IAccordionItemProps[] = [
  {
    icon: <Image src={AlternativeImg} width={56} height={56} />,
    title: `Продать старую и${NBSP}купить новую `,
    content: (
      <div style={itemStyles}>
        {`Организует всё так, чтобы сразу переехать в${NBSP}новую квартиру без${NBSP}суеты${NBSP}и${NBSP}временного жилья`}
      </div>
    ),
  },
  {
    icon: <Image src={CheckDetailsImg} width={56} height={56} />,
    title: `Проверить объект и${NBSP}избежать${NBSP}рисков`,
    content: (
      <div style={itemStyles}>
        {`Изучит документы, историю объекта и${NBSP}продавца, чтобы${NBSP}не${NBSP}потерять деньги и${NBSP}обезопасить сделку`}
      </div>
    ),
  },
  {
    icon: <Image src={BenefitImg} width={56} height={56} />,
    title: `Купить выгоднее рынка`,
    content: (
      <div style={itemStyles}>
        {`Подскажет, где можно торговаться, какие объекты переоценены и${NBSP}когда можно поймать лучшее${NBSP}предложение`}
      </div>
    ),
  },
];

export const WHY_NEED_REALTOR_SECOND_ACCORDION_COLUMNS: IAccordionItemProps[] = [
  {
    icon: <Image src={BudgetImg} width={56} height={56} />,
    title: `Уложиться в бюджет без${NBSP}потери${NBSP}качества`,
    content: (
      <div style={itemStyles}>
        {`Поможет снизить цену, договориться с продавцом и${NBSP}подобрать ипотеку с${NBSP}комфортным ежемесячным платежом`}
      </div>
    ),
  },
  {
    icon: <Image src={IncomeImg} width={56} height={56} />,
    title: `Купить квартиру под${NBSP}сдачу${NBSP}с${NBSP}доходом${LSEP}с${NBSP}первого${NBSP}месяца`,
    content: (
      <div style={itemStyles}>{`Рассчитает доходность и подберёт район, где аренда сразу перекрывает ипотеку`}</div>
    ),
  },
];
